import { css } from '@emotion/react'
import * as MQ from 'styles/media-queries'

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  padding: 40px 20px;
  
  ${MQ.PHONES} {
    min-height: 350px;
    padding: 30px 20px;
  }
`

export const textContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-width: 300px;
  margin-bottom: 15px;
  
  ${MQ.PHONES} {
    max-width: 280px;
    gap: 10px;
    margin-bottom: 10px;
  }
`

export const iconContainer = css`
  opacity: 0.8;
`

export const bookmarkImage = css`
  width: 360px;
  height: auto;
  
  ${MQ.PHONES} {
    width: 315px;
  }
`

export const title = css`
  text-align: center;
  
  ${MQ.PHONES} {
    font-size: 16px !important;
  }
`

export const subtitle = css`
  text-align: center;
  line-height: 1.5;
  opacity: 0.8;
  
  ${MQ.PHONES} {
    font-size: 13px !important;
    line-height: 1.4;
  }
` 